export const SET_USER = 'SET_USER';

export const SET_COURSE_LIST = 'SET_COURSE_LIST';

export const SET_COURSE = 'SET_COURSE';

export const SET_ACTIVITY_LIST = 'SET_ACTIVITY_LIST';

export const SET_ACTIVITY_COURSE_LIST = 'SET_ACTIVITY_COURSE_LIST';

export const SET_SCHOOL_LIST = 'SET_SCHOOL_LIST';

export const SET_SCHOOL = 'SET_SCHOOL';

export const SET_COACH_LIST = 'SET_COACH_LIST';

export const SET_COACH = 'SET_COACH';

export const SET_UPLOAD_COACH_LIST = 'SET_UPLOAD_COACH_LIST';

export const SET_ORDER_LIST = 'SET_ORDER_LIST';

export const SET_STOCK_LIST = 'SET_STOCK_LIST';

export const SET_STUDENT_LIST = 'SET_STUDENT_LIST';

export const SET_CERT_LIST = 'SET_CERT_LIST';

export const SET_CERT = 'SET_CERT';